// Screen `meetings` (owner: scheduling, owner feedback F13): meetings, meeting types, availability,
// insights and routing. The page loads with the route (plan §10.2); the URL is validated from the
// light `meeting-tabs` module.
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { BOOKING_LIST_SCOPES } from '@dataroom/core/search-enums';
import { MeetingsPage } from '../../../features/scheduling/MeetingsPage';
import { MEETING_TABS } from '../../../features/scheduling/meeting-tabs';
import { ModuleGate } from '../../../shell/ModuleGate';

export const Route = createFileRoute('/_app/meetings/')({
  validateSearch: z.object({
    tab: z.enum(MEETING_TABS).optional().catch(undefined),
    scope: z.enum(BOOKING_LIST_SCOPES).optional().catch(undefined),
    booking: z.uuid().optional().catch(undefined),
    q: z.string().max(200).optional().catch(undefined),
    owner: z.enum(['me', 'all']).optional().catch(undefined),
    view: z.enum(['ready', 'upcoming', 'attention']).optional().catch(undefined),
    rscope: z.enum(['mine', 'all']).optional().catch(undefined),
  }),
  component: function MeetingsRoute() {
    const search = Route.useSearch();
    return (
      <ModuleGate module="meetings">
        <MeetingsPage search={search} />
      </ModuleGate>
    );
  },
});
